<template>
  <CBox :bg="['none', 'var(--colors-light-primary-light-gray)']" minHeight="100vh" width="100vw" position="sticky">
    <OmtLayoutContainer>
      <OmtRow>
        <OmtButton
          mr="16px"
          size="sm"
          :variant="filtersCount > 0 ? 'solid' : 'outline'"
          leftIcon="sliders-h"
          :iconColor="filtersCount > 0 ? 'white' : 'var(--colors-light-primary-gray1)'"
          iconSize="sm"
          border=".5px solid var(--colors-light-secondary-divider)"
          :w="`${filtersCount > 0 ? 125 : 105}px !important`"
          @click="showFilterModal = true"
        >
          <OmtTypography as="button-small" :color="filtersCount > 0 ? 'white' : 'var(--colors-light-primary-gray1)'">
            Filtrar
          </OmtTypography>
          <CBox
            v-show="filtersCount"
            ml="16px"
            bg="var(--colors-light-secondary-light-blue)"
            border-radius="12px"
            min-h="16px"
            min-w="16px"
            h="16px"
            w="16px"
            display="flex"
            justify-content="center"
            align-items="center"
          >
            <OmtTypography as="p2" color="white">
              {{ filtersCount }}
            </OmtTypography>
          </CBox>
        </OmtButton>

        <SacListSortButtonVue :sorts="sorts" :initialValue="activedSort"
@sort="saveSorts($event)" />

        <OmtButton
          variant="ghost"
          :disabled="!hasFilterOrSort"
          size="sm"
          w="105px !important"
          ml="auto"
          pr="0"
          @click="cleanSortsAndFilters"
        >
          Limpar
        </OmtButton>
      </OmtRow>

      <OmtRow v-for="complaint in listaProtocolos" :key="complaint.protocol"
mt="24px">
        <RequestCard v-bind="complaint" @click="detailSac(complaint.protocol)" />
      </OmtRow>

      <FixedButtonRow>
        <OmtButton :w="['100%', '308px !important']" @click="createNewRequest">Nova solicitação</OmtButton>
      </FixedButtonRow>

      <SacFilterModal v-if="showFilterModal" :filters="filters" @close="showFilterModal = false" @save="saveFilters" />
    </OmtLayoutContainer>
  </CBox>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import RequestCard from "@/components/Organisms/Requests/RequestCard.vue";
import SacFilterModal from "@/components/Organisms/Sac/SacFilterModal.vue";
import SacListSortButtonVue from "@/components/Organisms/Sac/SacListSortButton.vue";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";

export default {
  name: "ProgramasSaudeList",
  components: {
    RequestCard,
    SacFilterModal,
    SacListSortButtonVue,
    FixedButtonRow
  },
  data() {
    return { showFilterModal: false };
  },
  computed: {
    ...mapState("programasSaude", ["filters", "sorts", "activedSort", "successRequest"]),
    ...mapGetters("programasSaude", ["listaProtocolos"]),
    filtersCount() {
      return this.filters?.totalActived ?? 0;
    },
    hasFilterOrSort() {
      return this.filtersCount > 0 || this.activedSort !== "";
    }
  },
  methods: {
    ...mapMutations("programasSaude", [
      "SET_FILTERS",
      "SET_SUCCESS_REQUEST",
      "SET_ACTIVED_SORT",
      "CLEAN_SORT_AND_FILTERS"
    ]),
    cleanSortsAndFilters() {
      this.CLEAN_SORT_AND_FILTERS();
    },
    createNewRequest() {
      this.$router.push("/programas-saude/criar");
    },
    saveFilters(filters) {
      this.SET_FILTERS(filters);
    },
    saveSorts(sorts) {
      this.SET_ACTIVED_SORT(sorts);
    },
    displaySuccessToast() {
      if (this.successRequest) {
        this.$toast({
          description: "Sua solicitação foi enviada com sucesso",
          status: "success",
          duration: 5000,
          position: "top"
        });
        this.SET_SUCCESS_REQUEST(false);
      }
    },
    detailSac(protocol) {
      this.$router.push({
        name: "programas-saude-detail",
        params: { protocol }
      });
    }
  },
  async mounted() {
    try {
      this.$root.$emit("show-loading");
      await this.$store.dispatch("programasSaude/fetchProtocolos");
      if (this.successRequest) this.displaySuccessToast();
    } catch (err) {
      console.error(err);
      this.$toast({ description: "Erro ao carregar solicitações", status: "warning" });
    } finally {
      this.$root.$emit("hide-loading");
    }
  }
};
</script>
